import { CirclePlus, Receipt, Trash, Users, UsersRound, WalletCards, Weight } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, convertThreeDecimalsWithoutZero, convertToNumber, convertTwoDecimalsOnValue, getDateAndTime, handleDateChange } from "../CommonComponents/CustomHooks";
import { CommonApiData, virtualPath } from "../CommonComponents/EnvConfig";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, SelectInputBox, Switch } from "../CommonComponents/InputBox";

const Shipment = () => {
    const inputrefs = useRef({})
    const dispatch = useDispatch()
    const loginUserClientCode = CommonApiData().loginUserClientCode;
    const [validateFeild, setValidateFeild] = useState({
        buisnessType: "",
        volumetricSelection: ""
    })
    const initialFormData = {
        isMannualAwbNo: false,
        isUpdateAwbNo: false,
        awbNo: "",
        refNo: "",
        pickupDate: getDateAndTime().date,
        client: loginUserClientCode,
        salesPerson: "",
        pickupPoint: "",
        bookingType: "Forward",
        buisnessType: "",
        serviceMode: "",
        volumetricSelection: "",

        isConsignorSave: false,
        consignorName: "",
        consignorCompanyName: "",
        consignorPinCode: "",
        consignorCity: "",
        consignorState: "",
        consignorAddress1: "",
        consignorAddress2: "",
        consignorAddress3: "",
        consignorMobileNo: "",
        consignorEmailID: "",
        consignorGSTNO: "",
        consignorAadharNo: "",

        isConsigneeSave: false,
        consigneeName: "",
        consigneeCompanyName: "",
        consigneePinCode: "",
        consigneeCity: "",
        consigneeState: "",
        consigneeAddress1: "",
        consigneeAddress2: "",
        consigneeAddress3: "",
        consigneeMobileNo: "",
        consigneeEmailID: "",
        consigneeGstNo: "",
        consigneeAadharNo: "",

        deliveryType: "DoorDelivery",
        expectedDeliveryDate: "",
        destinationBranch: "",

        isInsurance: false,
        insuranceValue: "",
        isVolWeight: false,

        totalPcs: "",
        actualWeight: "",
        totalWeight: "",
        totalChargeWeight: "",
        totalVolumetricWeight: "",

        packetDescription: "",

        weightDetails: [{
            pcs: "",
            boxNo: "System Generated",
            weight: "",
            boxDescription: "",
            length: "",
            width: "",
            height: "",
            volumetricWeight: ""
        }],
        invoiceDetails: [],
        paymentType: "",
        amount: "",
        packetType: "",
        serviceType: "",
        shipmentType: "",
        codAmount: "",
        remarks: "",
        pageType: "Packet Booking",
        divisor: '',
    };

    const [formData, setFormData] = useState(initialFormData);
    const [awbNoForPrint, setawbNoForPrint] = useState('')
    const loginData = CommonApiData();
    const isPcsMultiply = loginData?.isPcsMultiply;
    const GetPickupPoint = DropDownData('GetPickupPoint', formData.client)
    const getBookingType = DropDownData('GetPacketBookingType')
    const GetBuisnessType = DropDownData('GetBuisnessType')
    const GetServiceMode = DropDownData('GetServiceMode')
    const getVolumertricSelection = DropDownData('GetVolumetricSelection')
    const GetPacketType = DropDownData('GetPacketType')
    const GetServiceType = DropDownData('GetServiceTypeCode', formData.serviceMode)
    const GetPaymentType = DropDownData('GetPaymentType')
    const GetShipmentType = DropDownData('GetShipmentType')

    const handleClear = () => {
        setFormData(initialFormData);
        inputrefs.current['txtPickupDate'].focus()
    }

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...formData.weightDetails];
        updatedRows[index][field] = value;
        const length = parseFloat(updatedRows[index].length) || 0;
        const width = parseFloat(updatedRows[index].width) || 0;
        const height = parseFloat(updatedRows[index].height) || 0;
        const divisor = parseFloat(formData.divisor) || 5000;
        const cft = parseFloat(formData?.cft) || 1;
        const volumetricSelection = formData?.volumetricSelection
        const pcs = parseFloat(updatedRows[index].pcs) || 1;

        if (length && width && height && divisor) {
            const isInch = volumetricSelection?.toUpperCase() === 'INCH';
            let baseVolume = length * width * height;
            if (isInch && cft) {
                baseVolume *= cft;
            }
            if (isPcsMultiply && pcs) {
                baseVolume *= pcs;
            }
            const volWeight = baseVolume / divisor;
            updatedRows[index].volumetricWeight = Number(volWeight).toFixed(3);
        } else {
            updatedRows[index].volumetricWeight = "";
        }

        let updatedForm = {
            ...formData,
            weightDetails: updatedRows
        };

        if (field === "boxDescription") {

            const allDescriptions = updatedRows
                .map(r => r.boxDescription)
                .filter(Boolean)
                .join(", ");

            updatedForm.packetDescription = allDescriptions;
        }
        setFormData(updatedForm)
    };

    const handleDeleteRow = (index) => {
        const updated = formData.weightDetails.filter((_, i) => i !== index);
        const allDescriptions = updated
            .map(r => r.boxDescription)
            .filter(Boolean)
            .join(", ");
        setFormData({
            ...formData,
            weightDetails: updated,
            packetDescription: allDescriptions
        });
    };

    const handleAddRows = () => {
        setFormData(prev => {
            const rows = prev.weightDetails;
            const lastIndex = rows.length - 1;
            const lastRow = rows[lastIndex];



            if (!lastRow.pcs) {
                inputrefs.current[`pcs_${lastIndex}`]?.focus();
                return prev;
            }

            if (!lastRow.weight) {
                inputrefs.current[`weight_${lastIndex}`]?.focus();
                return prev;
            }

            if (prev.isVolWeight) {
                if (!lastRow.length) {
                    inputrefs.current[`length_${lastIndex}`]?.focus();
                    return prev;
                }
                if (!lastRow.width) {
                    inputrefs.current[`width_${lastIndex}`]?.focus();
                    return prev;
                }
                if (!lastRow.height) {
                    inputrefs.current[`height_${lastIndex}`]?.focus();
                    return prev;
                }
            }
            const totalEnteredPcs = rows.reduce((sum, r) => {
                return sum + (parseInt(r.pcs) || 0);
            }, 0);

            if (totalEnteredPcs >= (parseInt(prev.totalPcs) || 0)) {
                inputrefs.current[`pcs_${lastIndex}`]?.focus();

                NotificationSound("warning", "All pieces already added.!");

                return prev;
            }

            return {
                ...prev,
                weightDetails: [
                    ...rows,
                    {
                        pcs: "",
                        boxNo: "System Generated",
                        weight: "",
                        length: "",
                        width: "",
                        height: "",
                        volumetricWeight: "",
                        boxDescription: "",
                    }
                ]
            };
        });

        setTimeout(() => {
            const nextIndex = formData.weightDetails.length;
            inputrefs.current[`pcs_${nextIndex}`]?.focus();
        }, 100);
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Shipment/InsertUpdateShipmentEntry`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data?.focus, inputrefs, handleClear);
        if (data.status === 'SUCCESS') {
            setawbNoForPrint(data?.awbNo)
        }
    };

    const GetConsignorDetails = async (consignorName) => {
        await dispatch(setSubLoading(true));
        let payload = {
            ConsignorConsigneeCode: consignorName
        };
        let res = await ApiCall(`/api/Shipment/GetConsignorDetails`, payload);
        await dispatch(setSubLoading(false));
        if (res.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                consignorPinCode: res.data.consignorPinCode,
                consignorCity: res.data.consignorCity,
                consignorState: res.data.consignorState,
                consignorAddress1: res.data.consignorAddress1,
                consignorAddress2: res.data.consignorAddress2,
                consignorAddress3: res.data.consignorAddress3,
                consignorMobileNo: res.data.consignorMobileNo,
                consignorEmailID: res.data.consignorEmailID,
                consignorGSTNO: res.data.consignorGSTNO,
                consignorAadharNO: res.data.consignorAadharNO
            }));

        } else {
            setFormData((prev) => ({
                ...prev,
                consignorPinCode: "",
                consignorCity: "",
                consignorState: "",
                consignorAddress1: "",
                consignorAddress2: "",
                consignorAddress3: "",
                consignorMobileNo: "",
                consignorEmailID: "",
                consignorGSTNO: "",
                consignorAadharNO: "",
            }));
            //await NotificationSound(res.status, res.message, res?.focus, inputrefs);
            console.log("Error")
        }
    };

    const GetPickUpDetails = async (PickupPoint) => {
        await dispatch(setSubLoading(true));

        const payload = {
            Client: formData.client || "",
            PickupPoint: PickupPoint || ""
        };
        const res = await ApiCall(`/api/Shipment/GetConsignorByPickupPoint`, payload);
        await dispatch(setSubLoading(false));

        const isForward = formData?.bookingType?.toUpperCase() === "FORWARD";
        const prefix = isForward ? "consignor" : "consignee";

        if (res.status === "SUCCESS") {
            const response = res?.data || {};
            const sourceData = {
                Name: response.consignorName || "",
                CompanyName: response.consignorCompanyName || "",
                PinCode: response.consignorPinCode || "",
                City: response.consignorCity || "",
                State: response.consignorState || "",
                Address1: response.consignorAddress1 || "",
                Address2: response.consignorAddress2 || "",
                Address3: response.consignorAddress3 || "",
                MobileNo: response.consignorMobileNo || "",
                EmailID: response.consignorEmailID || "",
                GSTNO: response.consignorGSTNO || "",
                AadharNO: response.consignorAadharNO || ""
            };

            setFormData((prev) => ({
                ...prev,
                [`${prefix}Name`]: sourceData.Name,
                [`${prefix}CompanyName`]: sourceData.CompanyName,
                [`${prefix}PinCode`]: sourceData.PinCode,
                [`${prefix}City`]: sourceData.City,
                [`${prefix}State`]: sourceData.State,
                [`${prefix}Address1`]: sourceData.Address1,
                [`${prefix}Address2`]: sourceData.Address2,
                [`${prefix}Address3`]: sourceData.Address3,
                [`${prefix}MobileNo`]: sourceData.MobileNo,
                [`${prefix}EmailID`]: sourceData.EmailID,
                [`${prefix}GSTNO`]: sourceData.GSTNO,
                [`${prefix}AadharNO`]: sourceData.AadharNO
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [`${prefix}Name`]: "",
                [`${prefix}CompanyName`]: "",
                [`${prefix}PinCode`]: "",
                [`${prefix}City`]: "",
                [`${prefix}State`]: "",
                [`${prefix}Address1`]: "",
                [`${prefix}Address2`]: "",
                [`${prefix}Address3`]: "",
                [`${prefix}MobileNo`]: "",
                [`${prefix}EmailID`]: "",
                [`${prefix}GSTNO`]: "",
                [`${prefix}AadharNO`]: ""
            }));
            console.log("Error");
        }
    };


    const GetConsigneeDetails = async (consigneeName) => {
        await dispatch(setSubLoading(true));
        let payload = {
            ConsignorConsigneeCode: consigneeName
        };
        let res = await ApiCall(`/api/Shipment/GetConsigneeDetails`, payload);
        await dispatch(setSubLoading(false));
        if (res.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                consigneeCompanyName: res.data.consigneeCompanyName,
                consigneePinCode: res.data.consigneePinCode,
                consigneeCity: res.data.consigneeCity,
                consigneeState: res.data.consigneeState,
                consigneeAddress1: res.data.consigneeAddress1,
                consigneeAddress2: res.data.consigneeAddress2,
                consigneeAddress3: res.data.consigneeAddress3,
                consigneeMobileNo: res.data.consigneeMobileNo,
                consigneeEmailID: res.data.consigneeEmailID,
                consigneeGSTNO: res.data.consigneeGSTNO,
                consigneeAadharNO: res.data.consigneeAadharNO,
            }));

        } else {
            setFormData((prev) => ({
                ...prev,
                consigneeCompanyName: "",
                consigneePinCode: "",
                consigneeCity: "",
                consigneeState: "",
                consigneeAddress1: "",
                consigneeAddress2: "",
                consigneeAddress3: "",
                consigneeMobileNo: "",
                consigneeEmailID: "",
                consigneeGSTNO: "",
                consigneeAadharNO: "",
            }));
            //await NotificationSound(res.status, res.message, res?.focus, inputrefs);
            console.log("Error")
        }
    };

    const GetClientDetails = async (client) => {
        await dispatch(setSubLoading(true));

        let payload = {
            Client: client
        };
        let res = await ApiCall(`/api/Shipment/GetClientDetails`, payload);
        await dispatch(setSubLoading(false));
        if (res.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                consignorName: res?.data?.consignorName,
                consignorCompanyName: res?.data?.consignorCompanyName,
                consignorPinCode: res?.data?.consignorPinCode,
                consignorCity: res?.data?.consignorCity,
                consignorState: res?.data?.consignorState,
                consignorAddress1: res?.data?.consignorAddress1,
                consignorAddress2: res?.data?.consignorAddress2,
                consignorAddress3: res?.data?.consignorAddress3,
                consignorMobileNo: res?.data?.consignorMobileNo,
                consignorEmailID: res?.data?.consignorEmailID,
                consignorGSTNO: res?.data?.consignorGSTNO,
                consignorAadharNO: res?.data?.consignorAadharNO,
                paymentType: res?.data?.paymentType,
                salesPerson: res?.data?.salesPerson,
                divisor: res?.data?.divisor,
                buisnessType: res?.data?.buisnessType,
                volumetricSelection: res?.data?.volumetricSelection
            }));
            setValidateFeild({
                buisnessType: res?.data?.buisnessType,
                volumetricSelection: res?.data?.volumetricSelection
            })
        } else {
            setFormData((prev) => ({
                ...prev,
                consignorName: "",
                consignorCompanyName: "",
                consignorPinCode: "",
                consignorCity: "",
                consignorState: "",
                consignorAddress1: "",
                consignorAddress2: "",
                consignorAddress3: "",
                consignorMobileNo: "",
                consignorEmailID: "",
                consignorGSTNO: "",
                consignorAadharNO: "",
                paymentType: "",
                salesPerson: "",
                divisor: "",
                buisnessType: "",
                volumetricSelection: "",
            }));
            console.log("Error")
        }
    };

    //--Multiple Add Invoice--//
    const [isItemDetailsEdit, setIsItemDetailsEdit] = useState(false)
    const [editcontactIndex, setEditcontactIndex] = useState('')
    const [packetDetail, setPacketDetail] = useState({
        "invoiceNo": "",
        "invoiceDate": "",
        "invoiceValue": "",
        "ewayBillNo": "",
        "ewayBillExpDate": ""
    })

    // Validate contract Fields
    const ValidateItemDetails = async () => {

        const { invoiceNo, invoiceDate, invoiceValue, ewayBillNo, ewayBillExpDate } = packetDetail;

        if (!invoiceNo?.trim()) {
            await NotificationSound('Error', 'Please enter Invoice No!', 'txtInvoiceNo', inputrefs);
            return false;
        }

        if (!invoiceDate) {
            await NotificationSound('Error', 'Please select Invoice Date!', 'txtInvoiceDate', inputrefs);
            return false;
        }

        if (!invoiceValue?.toString().trim()) {
            await NotificationSound('Error', 'Please enter Invoice Value!', 'txtInvoiceValue', inputrefs);
            return false;
        }
        if (!ewayBillNo?.toString().trim() && Number(invoiceValue) >= 50000) {
            await NotificationSound('Error', 'Please enter Eway Bill No!', 'txtEWayBillNo', inputrefs);
            return false;
        }
        if (ewayBillNo !== "" && (ewayBillNo.length !== 10 && ewayBillNo.length !== 12)) {
            await NotificationSound('Error', 'Please enter valid Eway Bill No!', 'txtEWayBillNo', inputrefs);
            return false;
        }
        if (!ewayBillExpDate?.toString().trim() && Number(invoiceValue) >= 50000) {
            await NotificationSound('Error', 'Please enter Eway Bill Exp Date!', 'txtEWayBillExpDate', inputrefs);
            return false;
        }

        return true;
    };

    const getAwbDetails = async (awbNo) => {
        const body = {
            AwbNo: awbNo
        };
        await dispatch(setSubLoading(true))
        const res = await ApiCall("/api/Shipment/GetPickupAwbNoDetails", body);
        await dispatch(setSubLoading(false))
        if (res?.status === "SUCCESS") {
            setFormData((prev) => ({
                ...prev,
                ...res
            }));
            setawbNoForPrint(res?.awbNo)
        } else {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };

    const handleAddInvoice = async () => {
        const isValid = await ValidateItemDetails();
        if (!isValid) return;

        let updatedList = [...(formData.invoiceDetails || [])];

        if (isItemDetailsEdit) {
            updatedList[editcontactIndex] = { ...packetDetail };
        } else {
            updatedList.push({ ...packetDetail });
        }

        setFormData(prev => ({
            ...prev,
            invoiceDetails: updatedList
        }));

        handleClearInvoice();
    };

    // Edit
    const handleEditInvoice = (item, index) => {
        setPacketDetail({ ...item });
        setIsItemDetailsEdit(true);
        setEditcontactIndex(index);
    };


    const handleDeleteInvoice = (index) => {

        let updatedList = [...formData.invoiceDetails];
        updatedList.splice(index, 1);

        setFormData(prev => ({
            ...prev,
            invoiceDetails: updatedList
        }));

        handleClearInvoice();
    };


    // handle clear
    const handleClearInvoice = () => {
        setPacketDetail({
            invoiceNo: "",
            invoiceDate: "",
            invoiceValue: "",
            ewayBillNo: "",
            ewayBillExpDate: ""
        });
        setIsItemDetailsEdit(false);
        setEditcontactIndex('');
    };

    const GetCityStateByPincode = async (dataPayload, type) => {
        await dispatch(setSubLoading(true));
        let data = await ApiCall(`/api/Dashboard/GetPinCodeByCityState`, dataPayload);
        await dispatch(setSubLoading(false));

        if (data?.city || data?.state) {
            setFormData(prev => ({
                ...prev,
                ...(type === "consignor" && {
                    consignorCity: data?.city || "",
                    consignorState: data?.state || ""
                }),
                ...(type === "consignee" && {
                    consigneeCity: data?.city || "",
                    consigneeState: data?.state || "",
                    destinationBranch: data?.destinationBranch || ""
                })
            }));
        }
    };

    useEffect(() => {
        let totalWeight = 0;
        let totalVolWeight = 0;

        formData.weightDetails.forEach((row) => {
            const weight = parseFloat(row.weight) || 0;
            const pcs = parseInt(row.pcs) || 0;
            const volWeight = parseFloat(row.volumetricWeight) || 0;
            if (isPcsMultiply) {
                totalWeight += weight * pcs;
            } else {
                totalWeight += weight
            }
            totalVolWeight += volWeight;
        });

        const newTotalWeight = totalWeight.toFixed(3);
        const newVol = totalVolWeight.toFixed(3);

        const chargeWeight = Math.max(
            parseFloat(newTotalWeight),
            parseFloat(newVol)
        ).toFixed(3);

        if (
            formData.totalWeight !== newTotalWeight ||
            formData.totalVolumetricWeight !== newVol ||
            formData.totalChargeWeight !== chargeWeight ||
            formData.actualWeight !== newTotalWeight
        ) {
            setFormData((prev) => ({
                ...prev,
                actualWeight: newTotalWeight,
                totalWeight: newTotalWeight,
                totalVolumetricWeight: newVol,
                totalChargeWeight: chargeWeight
            }));
        }
    }, [formData.weightDetails]);


    const getDivisorAndCft = async (value, client, serviceMode) => {
        await dispatch(setSubLoading(true));

        let payload = {
            VolumetricSelection: value ? value : "",
            Client: client ? client : "",
            ServiceMode: serviceMode ? serviceMode : "",
        };

        let res = await ApiCall(
            `/api/Shipment/GetServiceDetails`,
            payload
        );

        await dispatch(setSubLoading(false));

        if (res.status === "SUCCESS") {
            const newDivisor = parseFloat(res?.data?.divisor) || 5000;
            const newCft = parseFloat(res?.data?.cft) || 1;

            setFormData((prev) => {
                const updatedRows = prev.weightDetails.map((row) => {
                    const length = parseFloat(row.length) || 0;
                    const width = parseFloat(row.width) || 0;
                    const height = parseFloat(row.height) || 0;
                    const pcs = parseFloat(row.pcs) || 1;

                    let updatedRow = { ...row };

                    if (length && width && height && newDivisor) {
                        const isInch =
                            prev?.volumetricSelection?.toUpperCase() ===
                            "INCH";

                        let baseVolume =
                            length * width * height;

                        if (isInch && newCft) {
                            baseVolume *= newCft;
                        }

                        if (isPcsMultiply && pcs) {
                            baseVolume *= pcs;
                        }

                        const volWeight =
                            baseVolume / newDivisor;

                        updatedRow.volumetricWeight =
                            Number(volWeight).toFixed(3);
                    } else {
                        updatedRow.volumetricWeight = "";
                    }

                    return updatedRow;
                });

                return {
                    ...prev,
                    divisor: newDivisor,
                    cft: newCft,
                    weightDetails: updatedRows,
                };
            });
        } else {
            setFormData((prev) => ({
                ...prev,
                divisor: 5000,
            }));
        }
    };

    //Docket Print
    const handlePrint = () => {
        const params = new URLSearchParams({
            awbNo: awbNoForPrint,

        });
        const url = `/Print/LabelPrint?${params.toString()}`;
        window.open(url, "_blank");
    };

    const handleSeeAndPrint = () => {
        window.open(
            `${virtualPath}/CNotePrint?AWBNo=${awbNoForPrint}`,
            "_blank"
        );
    };

    const handleLabelPrint = () => {
        window.open(
            `${virtualPath}/LabelPrint?AWBNo=${awbNoForPrint}`,
            "_blank"
        );
    };


    useEffect(() => {
        const data = GetServiceType?.data?.dropDownData;

        if (data && data.length === 1) {
            setFormData((prev) => ({
                ...prev,
                serviceType: data[0].valuePart
            }));
        }
    }, [GetServiceType]);


    useEffect(() => {
        document.title = `Shipment Entry`
        inputrefs.current['txtPickupDate'].focus()
        GetClientDetails(formData.client);
    }, [])

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3 pt-2 border-t-2 border-orange-400'>
                <div className="flex items-center justify-between mb-2 ">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <Users className="w-5 h-5 text-primary-600" />
                            <h2 className="text-xl font-semibold text-primary-600">
                                Shipment Entry
                            </h2>
                        </div>
                        <Switch
                            divclassname="flex items-center gap-1 scale-90"
                            id="txtUpdateAwbNo"
                            label="Update Docket No"
                            checked={formData.isUpdateAwbNo}
                            onChange={(e) => {
                                setFormData({ ...formData, isUpdateAwbNo: e.target.checked })
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    formData.isUpdateAwbNo ?
                                        inputrefs.current['txtAWBNo'].focus() :
                                        inputrefs.current['txtBookingDate'].focus();
                                }
                            }}
                        />

                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-6 gap-2">

                    <InputBox
                        id="txtAWBNo"
                        label="Docket No"
                        disabled={!(formData.isMannualAwbNo || formData.isUpdateAwbNo)}
                        placeholder={
                            !(formData.isMannualAwbNo || formData.isUpdateAwbNo)
                                ? "System Generated"
                                : "Enter Docket No"
                        }
                        value={formData.awbNo || ""}
                        onChange={(e) =>
                            setFormData({ ...formData, awbNo: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();

                                getAwbDetails(formData.awbNo);

                                inputrefs.current['txtPickupDate'].focus();
                            }
                        }}
                        labelclass="flex"
                        extraElement={
                            !formData.isUpdateAwbNo && (
                                <div className="ms-2 flex items-center gap-1">
                                    <input
                                        type="checkbox"
                                        id="txtManual"
                                        checked={formData.isMannualAwbNo}
                                        onChange={(e) =>
                                            setFormData({ ...formData, isMannualAwbNo: e.target.checked })
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                inputrefs.current['btnSub'].focus();
                                            }
                                        }}
                                    />
                                    <label htmlFor="txtManual" className="text-sm">
                                        Manual
                                    </label>
                                </div>
                            )
                        }
                    />

                    <DateBox
                        inputrefs={inputrefs}
                        label="Pickup Date"
                        placeholder=""
                        id="txtPickupDate"
                        required
                        selected={
                            formData?.pickupDate
                                ? new Date(formData.pickupDate)
                                : null
                        }
                        onChange={(date) =>
                            handleDateChange(date, setFormData, formData, 'pickupDate')
                        }
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtBookingType']?.focus()
                            }
                        }}
                    />

                    <SelectInputBox
                        id="txtBookingType"
                        value={formData.bookingType}
                        label='Booking Type'
                        required
                        onChange={(e) => setFormData({ ...formData, bookingType: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                inputrefs.current['txtPickupPoint'].focus();
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {getBookingType?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>


                    <AutoCompleteBoxNew
                        id="txtClient"
                        label="Client"
                        required
                        disabled
                        divclassname='col-span-2'
                        placeholder="Enter Client"
                        autocompleteType="GetClient"
                        value={formData.client || ''}
                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || '';
                            if (event.type !== 'keydown') {
                                const updatedData = { ...formData, client: newInputValue };
                                setFormData(updatedData);
                                GetClientDetails(newInputValue ? newInputValue : "")
                            }
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtPickupPoint'].focus()
                            }
                        }}
                    />


                    <SelectInputBox
                        id="txtPickupPoint"
                        value={formData.pickupPoint}
                        label='Pickup Point'

                        onChange={(e) => {
                            setFormData({ ...formData, pickupPoint: e.target.value })
                            GetPickUpDetails(e.target.value)
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                formData.buisnessType?.toUpperCase() !== '' ?
                                    inputrefs.current['txtServiceMode'].focus() :
                                    inputrefs.current['txtBuisnessType'].focus()
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {GetPickupPoint?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>

                    <SelectInputBox
                        id="txtBuisnessType"
                        value={formData.buisnessType}
                        disabled={validateFeild.buisnessType?.toUpperCase() !== ''}
                        label='Buisness Type'
                        required
                        onChange={(e) => setFormData({ ...formData, buisnessType: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                inputrefs.current['txtServiceMode'].focus()
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {GetBuisnessType?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>

                    <SelectInputBox
                        id="txtServiceMode"
                        value={formData.serviceMode}
                        label='Mode'
                        required
                        onChange={(e) => {
                            setFormData({ ...formData, serviceMode: e.target.value })
                            getDivisorAndCft(formData.volumetricSelection, formData?.client, e.target.value)
                        }}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                inputrefs.current['txtConsignorName'].focus()
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {GetServiceMode?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>

                </div>

            </div>

            <div className="grid grid-cols-2 gap-3">
                <div className="bg-white p-3 pt-2 rounded-md mt-3 shadow-md rounded-t-md border-t-4 border-green-600">
                    <div className="flex mb-2 items-center gap-2">
                        <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
                            <UsersRound size={18} />
                        </div>
                        <div className="flex justify-between items-center">

                            <h2 className="text-lg font-semibold text-gray-800">
                                Consignor Details
                            </h2>

                            <Switch
                                divclassname="ms-2 scale-90"
                                id="txtConsignorSave"
                                label="Consignor Save"
                                labelclass='flex items-center gap-2 cursor-pointer select-none'
                                checked={formData.isConsignorSave}
                                onChange={(e) =>
                                    setFormData({ ...formData, isConsignorSave: e.target.checked })
                                }
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        inputrefs.current['txtConsignorName'].focus()
                                    }
                                }}
                            />

                            <div className="flex items-center gap-1">
                                <input
                                    type="checkbox"
                                    id="txtInsurance"
                                    checked={formData.isInsurance}
                                    onChange={(e) =>
                                        setFormData({ ...formData, isInsurance: e.target.checked })
                                    }
                                />
                                <label htmlFor="txtInsurance" className="text-sm">
                                    Insurance
                                </label>
                            </div>

                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-x-3 gap-y-2 items-start">

                        <AutoCompleteBoxNew
                            id="txtConsignorName"
                            label="Consignor Name"
                            required
                            placeholder="Enter Consignor Name"
                            value={formData.consignorName || ""}
                            autocompleteType="GetConsignor"
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consignorName: newInputValue };
                                    setFormData(updatedData);
                                    GetConsignorDetails(newInputValue ? newInputValue : "")
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorCompanyName']?.focus();
                                }
                            }}
                            contextKey={formData.client}
                        />




                        <InputBox
                            id="txtConsignorCompanyName"
                            label="Company Name"
                            placeholder="Enter Company Name"
                            value={formData.consignorCompanyName}
                            onChange={(e) =>
                                setFormData({ ...formData, consignorCompanyName: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorPinCode']?.focus();
                                }
                            }}
                        />

                        <AutoCompleteBoxNew
                            id="txtConsignorPinCode"
                            label="Pincode"
                            required
                            placeholder="Enter Pincode"
                            autocompleteType="GetPinCode"
                            value={formData.consignorPinCode}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consignorPinCode: newInputValue };
                                    setFormData(updatedData);
                                    GetCityStateByPincode({ pincode: newInputValue }, "consignor");
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorCity']?.focus();
                                }
                            }}
                        />

                        <AutoCompleteBoxNew
                            id="txtConsignorCity"
                            label="City"
                            required
                            placeholder="Enter City"
                            autocompleteType="GetCityByPinCode"
                            value={formData.consignorCity}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consignorCity: newInputValue };
                                    setFormData(updatedData);
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorState']?.focus();
                                }
                            }}
                        //contextKey={formData.consigneePinCode }
                        />



                        <AutoCompleteBoxNew
                            id="txtConsignorState"
                            label="State"
                            required
                            placeholder="Enter State"
                            value={formData.consignorState}
                            autocompleteType="GetCityWiseState"
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consignorState: newInputValue };
                                    setFormData(updatedData);
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorAddress1']?.focus();
                                }
                            }}
                        //contextKey={formData.consigneePinCode }
                        />

                        <InputBox
                            id="txtConsignorAddress1"
                            label="Address 1"
                            required
                            placeholder="Enter Address 1"
                            value={formData.consignorAddress1}
                            onChange={(e) =>
                                setFormData({ ...formData, consignorAddress1: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorAddress2']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsignorAddress2"
                            label="Address 2"
                            placeholder="Enter Address 2"
                            value={formData.consignorAddress2}
                            onChange={(e) =>
                                setFormData({ ...formData, consignorAddress2: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorAddress3']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsignorAddress3"
                            label="Address 3"
                            placeholder="Enter Address 3"
                            value={formData.consignorAddress3}
                            onChange={(e) =>
                                setFormData({ ...formData, consignorAddress3: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorMobileNo']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsignorMobileNo"
                            label="Mobile No"
                            required
                            placeholder="Enter Mobile No"
                            value={formData.consignorMobileNo}
                            onChange={(e) =>
                                setFormData({ ...formData, consignorMobileNo: e.target.value })
                            }
                            maxlength="10"
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsignorEmailId']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsignorEmailId"
                            label="Email"
                            placeholder="Enter Email"
                            value={formData.consignorEmailID}
                            onChange={(e) =>
                                setFormData({ ...formData, consignorEmailID: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    formData.isInsurance ?
                                        inputrefs.current['txtInsuranceValue']?.focus() :
                                        inputrefs.current['txtConsigneeName']?.focus();
                                }
                            }}
                        />

                        {/*<InputBox*/}
                        {/*    id="txtConsignorGstNo"*/}
                        {/*    label="GST No"*/}
                        {/*    placeholder="Enter GST No"*/}
                        {/*    value={formData.consignorGSTNO}*/}
                        {/*    onChange={(e) =>*/}
                        {/*        setFormData({ ...formData, consignorGSTNO: e.target.value })*/}
                        {/*    }*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') {*/}
                        {/*            e.preventDefault();*/}
                        {/*            inputrefs.current['txtConsignorAadharNo']?.focus();*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*<InputBox*/}
                        {/*    id="txtConsignorAadharNo"*/}
                        {/*    label="Aadhaar No"*/}
                        {/*    placeholder="Enter Aadhaar No"*/}
                        {/*    value={formData.consignorAadharNo}*/}
                        {/*    onChange={(e) =>*/}
                        {/*        setFormData({ ...formData, consignorAadharNo: e.target.value })*/}
                        {/*    }*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') {*/}
                        {/*            e.preventDefault();*/}
                        {/*            // next section (Consignee start)*/}
                        {/*            inputrefs.current['txtConsigneeName']?.focus();*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*/>*/}

                        {/*<SelectInputBox*/}
                        {/*    id="txtDeliveryType"*/}
                        {/*    label="Delivery Type"*/}
                        {/*    value={formData.deliveryType}*/}

                        {/*    required={true}*/}
                        {/*    onChange={(e) => setFormData({ ...formData, deliveryType: e.target.value })}*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') {*/}
                        {/*            inputrefs.current['txtConsigneeName'].focus()*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <option value=''>--Please Select--</option>*/}
                        {/*    {GetDeliveryType?.data?.dropDownData?.map((item, index) =>*/}
                        {/*        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>*/}
                        {/*    )}*/}
                        {/*</SelectInputBox>*/}


                        {formData.isInsurance && (
                            <InputBox
                                id="txtInsuranceValue"
                                label="Insurance Value"
                                value={formData.insuranceValue}
                                maxLength='10'
                                onChange={(e) =>
                                    setFormData({ ...formData, insuranceValue: convertTwoDecimalsOnValue(e.target.value) })
                                }
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        inputrefs.current["txtConsigneeName"]?.focus();
                                    }
                                }}
                                placeholder="Enter Insurance Value"
                            />
                        )}
                    </div>
                </div>


                <div className="bg-white p-3 pt-2 rounded-md mt-3 shadow-md rounded-t-md border-t-4 border-blue-600">

                    <div className="flex mb-2 items-center gap-2">
                        <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
                            <UsersRound size={18} />
                        </div>
                        <div className="flex justify-between items-center">

                            <h2 className="text-lg font-semibold text-gray-800">
                                Consignee Details
                            </h2>

                            <Switch
                                divclassname="ms-2 scale-90"
                                id="txtConsigneeSave"
                                label="Consignee Save"
                                labelclass='flex items-center gap-2 cursor-pointer select-none'
                                checked={formData.isConsigneeSave}
                                onChange={(e) =>
                                    setFormData({ ...formData, isConsigneeSave: e.target.checked })
                                }
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        inputrefs.current['txtConsigneeName'].focus()
                                    }
                                }}
                            />

                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-x-3 gap-y-2 items-start">


                        <AutoCompleteBoxNew
                            id="txtConsigneeName"
                            label="Consignee Name"
                            required
                            placeholder="Enter Consignee Name"
                            value={formData.consigneeName || ""}
                            autocompleteType="GetConsignee"
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consigneeName: newInputValue };
                                    setFormData(updatedData);
                                    GetConsigneeDetails(newInputValue ? newInputValue : "")
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeCompanyName'].focus()
                                }
                            }}
                            contextKey={formData.client}
                        />

                        <InputBox
                            id="txtConsigneeCompanyName"
                            label="Company Name"
                            placeholder="Enter Company Name"
                            value={formData.consigneeCompanyName}
                            onChange={(e) =>
                                setFormData({ ...formData, consigneeCompanyName: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneePinCode']?.focus();
                                }
                            }}
                        />

                        <AutoCompleteBoxNew
                            id="txtConsigneePinCode"
                            label="Pincode"
                            placeholder="Enter Pincode"
                            autocompleteType="GetPinCode"
                            value={formData.consigneePinCode}
                            required
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consigneePinCode: newInputValue };
                                    setFormData(updatedData);
                                    GetCityStateByPincode({ pincode: newInputValue }, "consignee");
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeCity']?.focus();
                                }
                            }}
                        />

                        <AutoCompleteBoxNew
                            id="txtConsigneeCity"
                            label="City"
                            placeholder="Enter City"
                            autocompleteType="GetCityByPinCode"
                            required
                            value={formData.consigneeCity}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consigneeCity: newInputValue };
                                    setFormData(updatedData);
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeState']?.focus();
                                }
                            }}
                        //contextKey={formData.consigneePinCode }
                        />



                        <AutoCompleteBoxNew
                            id="txtConsigneeState"
                            label="State"
                            placeholder="Enter State"
                            value={formData.consigneeState}
                            required
                            autocompleteType="GetCityWiseState"
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || '';
                                if (event.type !== 'keydown') {
                                    const updatedData = { ...formData, consigneeState: newInputValue };
                                    setFormData(updatedData);
                                }
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeAddress1']?.focus();
                                }
                            }}
                        //contextKey={formData.consigneePinCode }
                        />




                        <InputBox
                            id="txtConsigneeAddress1"
                            label="Address 1"
                            placeholder="Enter Address 1"
                            required
                            value={formData.consigneeAddress1}
                            onChange={(e) =>
                                setFormData({ ...formData, consigneeAddress1: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeAddress2']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsigneeAddress2"
                            label="Address 2"
                            placeholder="Enter Address 2"
                            value={formData.consigneeAddress2}
                            onChange={(e) =>
                                setFormData({ ...formData, consigneeAddress2: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeAddress3']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsigneeAddress3"
                            label="Address 3"
                            placeholder="Enter Address 3"
                            value={formData.consigneeAddress3}
                            onChange={(e) =>
                                setFormData({ ...formData, consigneeAddress3: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeMobileNo']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsigneeMobileNo"
                            label="Mobile No"
                            placeholder="Enter Mobile No"
                            required
                            value={formData.consigneeMobileNo}
                            maxlength="10"
                            onChange={(e) =>
                                setFormData({ ...formData, consigneeMobileNo: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtConsigneeEmailId']?.focus();
                                }
                            }}
                        />

                        <InputBox
                            id="txtConsigneeEmailId"
                            label="Email"
                            placeholder="Enter Email"
                            value={formData.consigneeEmailID}
                            onChange={(e) =>
                                setFormData({ ...formData, consigneeEmailID: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtTotalPcs']?.focus();
                                }
                            }}
                        />
                    </div>

                </div>
            </div>

            <div className="mt-3 card-body shadow-lg rounded-t-md border-t-4 border-red-500 p-3 pt-2 bg-white">
                <div className="flex mb-2 items-center gap-2">
                    <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
                        <Weight size={18} />
                    </div>
                    <div className="flex items-center gap-3">
                        <h2 className="text-lg font-semibold text-gray-800 whitespace-nowrap">
                            Weight Details
                        </h2>

                        <InputBox
                            id="txtTotalPcs"
                            divclassname="col-5 flex justify-center items-center gap-1"
                            label='Total Pieces'
                            onFocus={(e) => e.target.select()}
                            maxLength="3"
                            value={formData.totalPcs}
                            onChange={(e) => {
                                const value = e.target.value;
                                setFormData({ ...formData, totalPcs: convertToNumber(value) });
                            }}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    if (formData.totalPcs === '') {
                                        NotificationSound('ERROR', 'Please Enter Total Pices.!')
                                        return
                                    }

                                    inputrefs.current["txtVolWeight"]?.focus();
                                }
                            }}
                            placeholder="Enter Pieces"
                        />

                        <div className="flex items-center gap-1">
                            <input
                                type="checkbox"
                                id="txtVolWeight"
                                ref={(ref) => { inputrefs.current["txtVolWeight"] = ref }}
                                checked={formData.isVolWeight}
                                onChange={(e) => {
                                    const checked = e.target.checked;

                                    setFormData(prev => ({
                                        ...prev,
                                        isVolWeight: checked,
                                        weightDetails: prev.weightDetails.map(row => ({
                                            ...row,
                                            length: checked ? row.length : "",
                                            width: checked ? row.width : "",
                                            height: checked ? row.height : "",
                                            volumetricWeight: checked ? row.volumetricWeight : ""
                                        }))
                                    }));
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        (formData.isVolWeight && validateFeild.volumetricSelection === '') ?
                                            inputrefs.current["txtVolumertricSelection"]?.focus() :
                                            inputrefs.current["pcs_0"]?.focus();
                                    }
                                }}
                            />
                            <label htmlFor="txtVolWeight" className="text-sm">
                                Volumetric
                            </label>
                        </div>
                        {formData.isVolWeight &&
                            <SelectInputBox
                                id="txtVolumertricSelection"
                                value={formData.volumetricSelection}
                                divclassname="col-2 flex justify-center items-center gap-1"
                                label=''
                                disabled={validateFeild.volumetricSelection !== ''}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({ ...formData, volumetricSelection: value })
                                    getDivisorAndCft(value, formData?.client, formData?.serviceMode)

                                }}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['pcs_0'].focus()
                                    }
                                }}
                            >
                                <option value=''>-Select-</option>
                                {getVolumertricSelection?.data?.dropDownData?.map((item, index) =>
                                    <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                )}
                            </SelectInputBox>
                        }

                    </div>
                </div>

                {formData?.weightDetails?.length > 0 && (
                    <div className="mt-2 w-full overflow-x-auto">
                        <table className="w-full border border-gray-300">

                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border p-2">Pieces</th>
                                    <th className="border p-2">Weight</th>

                                    {formData.isVolWeight && (
                                        <>
                                            <th className="border p-2">Length</th>
                                            <th className="border p-2">Width</th>
                                            <th className="border p-2">Height</th>
                                            <th className="border p-2">Volumetric Weight</th>
                                        </>
                                    )}
                                    <th className="border p-2">Description</th>
                                    <th className="border p-2">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {formData.weightDetails.map((item, index) => (
                                    <tr key={index}>
                                        {/* PCS */}
                                        <td className="border p-1">
                                            <InputBox
                                                id={`pcs_${index}`}
                                                inputrefs={inputrefs}
                                                onFocus={(e) => e.target.select()}
                                                value={item.pcs}
                                                maxLength='3'
                                                onChange={(e) => {
                                                    const value = convertToNumber(e.target.value);
                                                    const updatedRows = [...formData.weightDetails];
                                                    updatedRows[index].pcs = value;
                                                    const totalEnteredPcs = updatedRows.reduce((sum, row, i) => {
                                                        return sum + (parseInt(row.pcs) || 0);
                                                    }, 0);
                                                    if (formData.totalPcs === '') {
                                                        NotificationSound("ERROR", "Please enter Total Pieces.!", 'txtTotalPcs', inputrefs);
                                                        return;
                                                    }
                                                    if (totalEnteredPcs > (parseInt(formData.totalPcs) || 0)) {
                                                        NotificationSound("ERROR", `Total pieces cannot be greter then Total Pieces : ${formData.totalPcs}.`);
                                                        return;
                                                    }
                                                    handleRowChange(index, "pcs", value);
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        inputrefs.current[`weight_${index}`]?.focus();
                                                    }
                                                }}
                                                placeholder="Enter Pieces"
                                            />
                                        </td>

                                        {/* WEIGHT */}
                                        <td className="border p-1">
                                            <InputBox
                                                id={`weight_${index}`}
                                                inputrefs={inputrefs}
                                                onFocus={(e) => e.target.select()}
                                                value={item.weight}
                                                maxLength='10'
                                                onChange={(e) =>
                                                    handleRowChange(index, "weight", convertThreeDecimalsWithoutZero(e.target.value))
                                                }
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault()
                                                        if (formData.isVolWeight) {
                                                            inputrefs.current[`length_${index}`]?.focus();
                                                        } else {
                                                            inputrefs.current[`BoxDescription_${index}`]?.focus();
                                                        }
                                                    }
                                                }}
                                                placeholder="Enter Weight"
                                            />
                                        </td>

                                        {formData.isVolWeight && (
                                            <>
                                                {/* LENGTH */}
                                                <td className="border p-1">
                                                    <InputBox
                                                        id={`length_${index}`}
                                                        inputrefs={inputrefs}
                                                        onFocus={(e) => e.target.select()}
                                                        value={item.length}
                                                        maxLength='7'
                                                        onChange={(e) =>
                                                            handleRowChange(index, "length", convertTwoDecimalsOnValue(e.target.value))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                inputrefs.current[`width_${index}`]?.focus();
                                                            }
                                                        }}
                                                        placeholder="Enter Length"
                                                    />
                                                </td>

                                                {/* WIDTH */}
                                                <td className="border p-1">
                                                    <InputBox
                                                        id={`width_${index}`}
                                                        inputrefs={inputrefs}
                                                        onFocus={(e) => e.target.select()}
                                                        maxLength='7'
                                                        value={item.width}
                                                        onChange={(e) =>
                                                            handleRowChange(index, "width", convertTwoDecimalsOnValue(e.target.value))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                inputrefs.current[`height_${index}`]?.focus();
                                                            }
                                                        }}
                                                        placeholder="Enter Width"
                                                    />
                                                </td>

                                                {/* HEIGHT */}
                                                <td className="border p-1">
                                                    <InputBox
                                                        id={`height_${index}`}
                                                        inputrefs={inputrefs}
                                                        onFocus={(e) => e.target.select()}
                                                        value={item.height}
                                                        maxLength='7'
                                                        onChange={(e) =>
                                                            handleRowChange(index, "height", convertTwoDecimalsOnValue(e.target.value))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.preventDefault()
                                                                inputrefs.current[`BoxDescription_${index}`]?.focus();
                                                            }
                                                        }}
                                                        placeholder="Enter Height"
                                                    />
                                                </td>

                                                {/* VOLUMETRIC */}
                                                <td className="border p-1">
                                                    <InputBox
                                                        value={item.volumetricWeight}
                                                        disabled
                                                        placeholder="Auto"
                                                    />
                                                </td>
                                            </>
                                        )}

                                        {/* Box Description */}
                                        <td className="border p-1">
                                            <InputBox
                                                id={`BoxDescription_${index}`}
                                                inputrefs={inputrefs}
                                                value={item.boxDescription}
                                                maxLength='250'
                                                onChange={(e) =>
                                                    handleRowChange(index, "boxDescription", (e.target.value))
                                                }
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault()
                                                        if (formData?.weightDetails?.length - 1 === index) {
                                                            inputrefs.current[`btnAdd`]?.focus();
                                                        } else {
                                                            inputrefs.current[`pcs_${index + 1}`]?.focus();
                                                        }
                                                    }
                                                }}
                                                placeholder="Enter Description"
                                            />
                                        </td>

                                        {/* ACTION */}
                                        <td className="border text-center w-20">
                                            <div className='flex gap-2 items-center justify-center'>
                                                {index === formData.weightDetails.length - 1 &&
                                                    <button
                                                        ref={(ref) => { inputrefs.current["btnAdd"] = ref }}
                                                        className="text-green-500 rounded"
                                                        onClick={() => handleAddRows(index)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                inputrefs.current[`txtPacketDescription`]?.focus();
                                                            }
                                                        }}
                                                    >
                                                        <CirclePlus size={18} />
                                                    </button>
                                                }
                                                {formData.weightDetails.length !== 1 &&
                                                    < button
                                                        className="text-red-500 rounded"
                                                        onClick={() => handleDeleteRow(index)}
                                                    >
                                                        <Trash size={18} />
                                                    </button>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                )}


                <div className="grid grid-cols-1 md:grid-cols-5 mt-3 gap-3">

                    {/*<InputBox*/}
                    {/*    id="txtActualWeight"*/}
                    {/*    label="Actual Weight"*/}
                    {/*            value={formData.actualWeight}*/}
                    {/*    disabled*/}
                    {/*    onChange={(e) =>*/}
                    {/*        setFormData({ ...formData, actualWeight: e.target.value })*/}
                    {/*    }*/}
                    {/*    inputrefs={inputrefs}*/}
                    {/*    onKeyDown={(e) => {*/}
                    {/*        if (e.key === "Enter") {*/}
                    {/*            e.preventDefault();*/}
                    {/*            inputrefs.current["txtTotalWeight"]?.focus();*/}
                    {/*        }*/}
                    {/*        }}*/}
                    {/*        placeholder="Enter Actual Weight"*/}
                    {/*/>*/}

                    <InputBox
                        id="txtTotalWeight"
                        label="Total Actual Weight"
                        disabled
                        value={formData.totalWeight}
                        onChange={(e) =>
                            setFormData({ ...formData, totalWeight: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtTotalChargeWeight"]?.focus();
                            }
                        }}
                        placeholder="Enter Total Weight"
                    />

                    <InputBox
                        id="txtTotalVolumetricWeight"
                        label="Total Volumetric Weight"
                        disabled
                        value={formData.totalVolumetricWeight}
                        onChange={(e) =>
                            setFormData({ ...formData, totalVolumetricWeight: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtPacketDescription"]?.focus();
                            }
                        }}
                        placeholder="Enter Charge Weight"
                    />
                    <InputBox
                        id="txtTotalChargeWeight"
                        label="Total Charge Weight"
                        disabled
                        value={formData.totalChargeWeight}
                        onChange={(e) =>
                            setFormData({ ...formData, totalChargeWeight: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtTotalVolumetricWeight"]?.focus();
                            }
                        }}
                        placeholder="Enter Charge Weight"
                    />


                    <InputBox
                        id="txtPacketDescription"
                        label="Packet Description"
                        value={formData.packetDescription}
                        onChange={(e) =>
                            setFormData({ ...formData, packetDescription: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                formData.paymentType === "COD" || formData.paymentType === "CASH" ?
                                    inputrefs.current['txtAmount'].focus() :
                                    inputrefs.current['txtPacketType'].focus();
                            }
                        }}
                        placeholder="Enter Packet Description"
                    />

                </div>
            </div >


            <div className="mt-3 card-body shadow-lg rounded-t-md border-t-4 border-yellow-500 p-3 pt-2 bg-white">

                <div className="flex mb-2 items-center gap-2">
                    <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
                        <WalletCards size={18} />
                    </div>
                    <div>
                        <h2 className="text-lg font-semibold text-gray-800">
                            Payment Details
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                    <SelectInputBox
                        id="txtPaymentType"
                        value={formData.paymentType}
                        label='Payment Type'
                        disabled
                        required={true}
                        onChange={(e) => setFormData({ ...formData, paymentType: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                formData.paymentType === "COD" || formData.paymentType === "CASH" ?
                                    inputrefs.current['txtAmount'].focus() :
                                    inputrefs.current['txtPacketType'].focus();
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {GetPaymentType?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>
                    {(formData.paymentType === "COD" || formData.paymentType === "CASH") && (
                        <InputBox
                            id="txtAmount"
                            label="Amount"
                            placeholder="Enter Amount"
                            required
                            value={formData.amount}
                            onChange={(e) =>
                                setFormData({ ...formData, amount: convertThreeDecimalsWithoutZero(e.target.value) })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtPacketType']?.focus();
                                }
                            }}
                        />
                    )}


                    <SelectInputBox
                        id="txtPacketType"
                        value={formData.packetType}
                        label='Packet Type'
                        required={true}
                        onChange={(e) => setFormData({ ...formData, packetType: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                inputrefs.current['txtServiceType'].focus()
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {GetPacketType?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>

                    <SelectInputBox
                        id="txtServiceType"
                        value={formData.serviceType}
                        label='Service Type'
                        required={true}
                        onChange={(e) => setFormData({ ...formData, serviceType: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                inputrefs.current['txtShipmentType'].focus()
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {GetServiceType?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>


                    <SelectInputBox
                        id="txtShipmentType"
                        value={formData.shipmentType}
                        label='Shipment Type'
                        required={true}
                        onChange={(e) => setFormData({ ...formData, shipmentType: e.target.value })}
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                formData.shipmentType === "COD" ?
                                    inputrefs.current['txtCODAmount'].focus() :
                                    inputrefs.current['txtRemarks'].focus();
                            }
                        }}
                    >
                        <option value=''>--Please Select--</option>
                        {GetShipmentType?.data?.dropDownData?.map((item, index) =>
                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                        )}
                    </SelectInputBox>

                    {formData.shipmentType === "COD" && (
                        <InputBox
                            id="txtCODAmount"
                            label="COD Amount"
                            placeholder="Enter COD Amount"
                            maxLength='20'
                            value={formData.codAmount}
                            onChange={(e) =>
                                setFormData({ ...formData, codAmount: convertTwoDecimalsOnValue(e.target.value) })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtRemarks']?.focus();
                                }
                            }}
                        />
                    )}


                    <InputBox
                        id="txtRemarks"
                        label="Remarks"
                        placeholder="Enter Remarks"
                        value={formData.remarks}
                        onChange={(e) =>
                            setFormData({ ...formData, remarks: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtInvoiceNo']?.focus();
                            }
                        }}
                    />


                </div>
            </div>

            <div className="mt-3 card-body shadow-lg rounded-t-md border-t-4 border-orange-500 p-3 pt-2 bg-white">

                <div className="flex mb-2 items-center gap-2">
                    <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
                        <Receipt size={18} />
                    </div>
                    <div>
                        <h2 className="text-lg font-semibold text-gray-800">
                            Invoice Details
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
                    <InputBox
                        id="txtInvoiceNo"
                        label="Invoice No"
                        value={packetDetail.invoiceNo}
                        onChange={(e) =>
                            setPacketDetail({ ...packetDetail, invoiceNo: e.target.value })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtInvoiceDate"]?.focus();
                            }
                        }}
                        placeholder="Enter Invoice No"
                    />

                    <DateBox
                        id="txtInvoiceDate"
                        label="Invoice Date"
                        maxDate={new Date()}
                        value={packetDetail.invoiceDate}
                        inputrefs={inputrefs}
                        selected={
                            packetDetail?.invoiceDate
                                ? new Date(packetDetail.invoiceDate)
                                : null
                        }
                        onChange={(date) =>
                            handleDateChange(date, setPacketDetail, packetDetail, 'invoiceDate')
                        }
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtInvoiceValue']?.focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtInvoiceValue"
                        label="Invoice Value"
                        value={packetDetail.invoiceValue}
                        onChange={(e) =>
                            setPacketDetail({ ...packetDetail, invoiceValue: convertTwoDecimalsOnValue(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtEWayBillNo"]?.focus();
                            }
                        }}
                        placeholder="Enter Invoice Value"
                    />

                    <InputBox
                        id="txtEWayBillNo"
                        label="E-Way Bill No"
                        maxLength='12'
                        value={packetDetail.ewayBillNo}
                        onChange={(e) =>
                            setPacketDetail({ ...packetDetail, ewayBillNo: convertToNumber(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                inputrefs.current["txtEWayBillExpDate"]?.focus();
                            }
                        }}
                        placeholder="Enter EWay Bill No"
                    />

                    <DateBox
                        id="txtEWayBillExpDate"
                        label="E-Way Bill Exp Date"
                        minDate={new Date()}
                        value={packetDetail.ewayBillExpDate}
                        inputrefs={inputrefs}
                        selected={
                            packetDetail?.ewayBillExpDate
                                ? new Date(packetDetail.ewayBillExpDate)
                                : null
                        }
                        onChange={(date) =>
                            handleDateChange(date, setPacketDetail, packetDetail, 'ewayBillExpDate')
                        }
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSaveContact']?.focus()
                            }
                        }}
                    />

                    <div className="col-md-2 flex gap-2 mt-2 items-center">

                        <button
                            type="button"
                            id="btnSaveContact"
                            ref={ref => (inputrefs.current["btnSaveContact"] = ref)}
                            onClick={handleAddInvoice}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['btnSub']?.focus()
                                }
                            }}
                            className="bg-cyan-400 p-2 text-white w-[22px] h-[22px] rounded-full text-[10px] inline-flex items-center justify-center"
                        >
                            <i className="fa-solid fa-plus"></i>
                        </button>

                        <button
                            type="button"
                            onClick={handleClearInvoice}
                            className="bg-red-500 p-2 text-white w-[22px] h-[22px] rounded-full text-[10px] inline-flex items-center justify-center"
                        >
                            <i className="fa-solid fa-arrow-rotate-left"></i>
                        </button>

                    </div>

                </div>

                {formData?.invoiceDetails?.length > 0 && (
                    <table className="table table-bordered mt-3">
                        <thead>
                            <tr>
                                <th>Invoice No</th>
                                <th>Date</th>
                                <th>Value</th>
                                <th>EWay Bill No</th>
                                <th>Exp Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {formData.invoiceDetails.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.invoiceNo}</td>
                                    <td>{item.invoiceDate}</td>
                                    <td>{item.invoiceValue}</td>
                                    <td>{item.ewayBillNo}</td>
                                    <td>{item.ewayBillExpDate}</td>

                                    <td>
                                        <i
                                            className="fa-regular fa-pen-to-square text-success me-2 cursor-pointer"
                                            onClick={() => handleEditInvoice(item, index)}
                                        />

                                        <i
                                            className="fa-regular fa-trash-can text-danger cursor-pointer"
                                            onClick={() => handleDeleteInvoice(index)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        Export={false}
                        handleSubmit={handleSubmit}
                        handleClear={handleClear}
                        isPrint={false}
                        PrintText={'Docket Print'}
                        handlePrint={handlePrint}
                        SeeAndPrint={!!awbNoForPrint}
                        handleSeeAndPrint={handleSeeAndPrint}
                        LabelPrint={!!awbNoForPrint}
                        handleLabelPrint={handleLabelPrint}
                    />
                </div>

            </div>

        </>
    )
}
export default Shipment;